import { AuditAction } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export { AuditAction };

export const auditActionDictionary = createSimpleDictionary([
    { id: AuditAction.Add, name: 'dictionaries.auditAction.add' },
    { id: AuditAction.Update, name: 'dictionaries.auditAction.update' },
    { id: AuditAction.Delete, name: 'dictionaries.auditAction.delete' },
]);
